import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core";

import { CARD_TYPES } from "features/planner/planner.constants";
import DummyCard from "features/planner/components/Card/DummyCard";
import { getCardFromState } from "features/planner/planner.selectors";
import EmployeeCard from "features/planner/components/Card/EmployeeCard/EmployeeCard";

class CardSearchResult extends PureComponent {
  render() {
    const { card, cardId, classes } = this.props;

    const isDummyCard = card.get("type") === CARD_TYPES.DUMMY;

    return React.createElement(isDummyCard ? DummyCard : EmployeeCard, {
      card,
      cardId,
      displayDeleteBtn: false,
      displayDropdownMenu: false,
      classes: {
        root: classes.root,
      },
    });
  }
}

const styles = theme => ({
  root: {
    height: theme.spacing(3),
  },
});

export default compose(
  connect((state, { cardId }) => ({
    card: getCardFromState(state, cardId),
  })),
  withStyles(styles),
)(CardSearchResult);
